import {
    GET_ALL_INTEGRATOR_SYSTEM,
    OBTENER_USUARIOS_CLIENTE,
    OBTENER_CLIENTES_INTEGRADOR,
    OBTENER_SOPORTES,
    OBTENER_ALERTASXCLIENTE,
    OBTENER_ALERTASXDISTRITO,
    OBTENER_ALERTASENVIADAS,
    OBTENER_DISPOSITIVOSDEVEUI,
    OBTENER_DISPOSITIVOSUBICACION,
    OBTENER_DISPOSITIVOSCLIENTE,
    OBTENER_DISPOSITIVOSMODELO,
    OBTENER_DISPOSITIVOSESTADO,
    OBTENER_DISPOSITVOSPAQUETES,
    OBTENER_DISPOSITVOSPAQUETESPERDIDOS
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_USUARIOS_CLIENTE:
            return{
                ...state,
                usuariosCliente:action.payload
            }
        case GET_ALL_INTEGRATOR_SYSTEM:
            return{
                ...state,
                integratorsList:action.payload
            }           
        case OBTENER_CLIENTES_INTEGRADOR:
            return{
                ...state,
                clientesIntegrador:action.payload
            }
        case OBTENER_SOPORTES:
            return{
                ...state,
                soportes:action.payload
            }
        case    OBTENER_ALERTASXCLIENTE:
            return{
                ...state,
                alertasxcliente:action.payload
            }
        case   OBTENER_ALERTASXDISTRITO:
            return{
                ...state,
                alertasxdistrito:action.payload
            }
        case   OBTENER_ALERTASENVIADAS:
            return{
                ...state,
                alertasenviadas:action.payload
            }
        case    OBTENER_DISPOSITIVOSDEVEUI:
            return{
                ...state,
                alertasenviadas:action.payload
            }
        case OBTENER_DISPOSITIVOSUBICACION:
            return{
                ...state,
                data:action.payload
            }
        case OBTENER_DISPOSITIVOSCLIENTE:
            return{
                ...state,
                data:action.payload
            }
        case OBTENER_DISPOSITIVOSMODELO:
            return{
                ...state,
                data:action.payload
            }
        case OBTENER_DISPOSITIVOSESTADO:
            return{
                ...state,
                data:action.payload
            }
        case OBTENER_DISPOSITVOSPAQUETES:
            return{
                ...state,
                data:action.payload
            }
        case OBTENER_DISPOSITVOSPAQUETESPERDIDOS:
            return{
                ...state,
                data:action.payload
            }
        default:
            return state;
    }
}